import type { FC } from 'react';
import PropTypes from 'prop-types';
import { useContentAsset } from '../../utils/api';
import { Content } from './Content';

interface Props {
    className?: string;
    contentAssetId: string;
}

export const ContentAsset: FC<Props> = ({ contentAssetId, className }) => {
    const serverHtml = useContentAsset(contentAssetId);
    return <Content serverHtml={serverHtml} className={className} />;
};

ContentAsset.propTypes = {
    contentAssetId: PropTypes.string.isRequired,
    className: PropTypes.string,
};

ContentAsset.defaultProps = {
    className: undefined,
};
